import Vue from 'vue';
import Router, { Route, RouteConfig } from 'vue-router';
import seekerRoutes from './seekerRoutes';
import providerRoutes from './providerRoutes';
import store from '../store';
import segmentPageviews from './guards/segmentPageviews';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [...seekerRoutes, ...providerRoutes] as RouteConfig[],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Scroll to saved position
    }
    return { x: 0, y: 0 }; // Scroll to the top
  },
});

// WARNING
// If you add beforeEach or afterEach guards, the code will be executed on every page
// You may want to use beforeEnter instead.
// Be careful and write tests~~~

router.beforeEach(async (to, from, next) => {
  // get account data if not already fetched
  try {
    await store.dispatch('account/fetchAccountData');
  } catch (error) {
    console.error('Failed to fetch account data', error);
    // redirect to login or show an error page
  }

  return next();
});

router.afterEach(segmentPageviews);

// Utility function to update login links with current return_path
function updateLoginLinks(returnPath: string): void {
  // Update main login links - replace any existing return_path
  document.querySelectorAll('a[href*="/login"]').forEach((link) => {
    const anchorLink = link as HTMLAnchorElement;
    const baseHref = anchorLink.getAttribute('href');
    if (baseHref) {
      // Remove any existing return_path parameter
      const url = new URL(baseHref, window.location.origin);
      url.searchParams.delete('return_path');
      url.searchParams.set('return_path', returnPath);
      anchorLink.href = url.pathname + url.search;
    }
  });
}

router.afterEach((to: Route) => {
  const returnPath = encodeURIComponent(to.fullPath);
  updateLoginLinks(returnPath);
});

export default router;
